import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import { TRANSLATION_GROUP_SIDEBAR } from '@modules/sidebar/constants';

import {
  ADMIN_DASHBOARD_ROUTE_NAME,
  AFFILIATE_DASHBOARD_ROUTE_NAME,
  TRANSLATION_GROUP_DASHBOARD_ADMIN,
  TRANSLATION_GROUP_DASHBOARD_AFFILIATE,
} from './constants';
import {
  getDashboardAdminTranslations,
  getDashboardAffiliateTranslations,
} from './translations';

export class DashboardModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_DASHBOARD_ROUTE_NAME,
      path: 'dashboard',
      component: () => import('./pages/DashboardPage/DashboardPage.vue'),
    });

    router.addAffiliateRoute({
      name: AFFILIATE_DASHBOARD_ROUTE_NAME,
      path: 'dashboard',
      component: () => import('./pages/DashboardPage/DashboardPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addAdminMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'ADMIN_HOME'),
      icon: 'pi pi-home',
      to: {
        name: ADMIN_DASHBOARD_ROUTE_NAME,
      },
      id: ADMIN_DASHBOARD_ROUTE_NAME,
      order: 10,
    });

    menu.addAffiliateMenuItem({
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'AFFILIATE_HOME'),
      icon: 'pi pi-home',
      to: {
        name: AFFILIATE_DASHBOARD_ROUTE_NAME,
      },
      id: AFFILIATE_DASHBOARD_ROUTE_NAME,
      order: 10,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_DASHBOARD_ADMIN, getDashboardAdminTranslations);
    mapper.addTranslationsMap(TRANSLATION_GROUP_DASHBOARD_AFFILIATE, getDashboardAffiliateTranslations);
  }
}
